export default "__VITE_ASSET__8c66c6ad__"